module.exports = __webpack_public_path__ + "img/20200102155032360截图20200102112059367.c89905ed.jpg";